import CreateColumn from '../../../../Services/agGrid/createColumn';

/**
 * 리팩토링된 컬럼 정의 생성 함수
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // 1. NO (체크박스) 컬럼
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      maxWidth: 80,
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow1,
        gridRef: props.gridRef1,
        rowData: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef1,
        lastCheckedIndexRef: props.lastCheckedIndexRef1,
        handleRowSelection: props.handleRowSelection,
      },
    }),

    // 2. 회사코드 (숨김)
    CreateColumn('coCd', '회사코드', 'left', 100, false, false, true),

    // 3. 자사양식여부 (Y/N 포맷터 적용)
    CreateColumn(
      'fileName',
      '자사양식여부',
      'center',
      130,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 130,
        valueFormatter: (params) => (params.value ? 'Y' : 'N'),
      }
    ),

    // 4. 파일명
    CreateColumn(
      'fileName',
      '파일명',
      'left',
      250,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 250,
      }
    ),

    // 5. 작성일 (date 타입 활용하여 날짜 로직 자동화)
    CreateColumn('date', '작성일', 'center', 100, true, true, false, 'date', {
      minWidth: 100,
      // CreateColumn 내부의 date 처리 로직이 있으므로 별도의 formatter/parser 생략 가능
      // 만약 특수한 비교 로직(기존값 유지 등)이 꼭 필요하다면 아래처럼 추가 가능합니다.
      valueParser: (params) => {
        if (!params.newValue) return null;
        const [year, month, day] = params.newValue.split('-');
        const parsedDate = new Date(
          Date.UTC(year, month - 1, day)
        ).toISOString();
        if (parsedDate.substr(0, 10) === params.oldValue?.substr(0, 10)) {
          return params.oldValue;
        }
        return parsedDate;
      },
    }),

    // 6. 첨부파일 (숨김)
    CreateColumn('mapFile', '첨부파일', 'left', 100, false, false, true),

    // 7. 파일 업로드 (upload 타입 활용)
    CreateColumn(
      'upload',
      '파일 업로드',
      'center',
      130,
      false,
      false,
      false,
      'upload',
      {
        pinned: 'right',
        uploadProps: {
          label: '업로드',
          gridRef: props.gridRef1,
          props: { ...props, blockVideo: true },
        },
      }
    ),

    // 8. 파일 다운로드 (download 타입 활용)
    CreateColumn(
      'download',
      '파일 다운로드',
      'center',
      140,
      false,
      false,
      false,
      'download',
      {
        pinned: 'right',
        downloadButtonText: '파일 다운로드',
        downloadClickHandler: (data) => props.DownloadLogic2(data),
      }
    ),

    // 9. 기타 숨김 컬럼들
    CreateColumn('mapBlob', '블롭', 'left', 100, false, false, true),
    CreateColumn('mapFile', '파일', 'left', 100, false, false, true),
    CreateColumn(
      'mapFileName',
      '파일명(사용자가 올린 이름)',
      'left',
      100,
      false,
      false,
      true
    ),
    CreateColumn(
      'saveName',
      '파일명(저장되는 이름)',
      'left',
      100,
      false,
      false,
      true
    ),
    CreateColumn(
      'previewFilePath',
      '미리보기 주소',
      'left',
      100,
      false,
      false,
      true
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
};

export default columnDefs;
